<template>
  <div class="d-flex align-items-center">
    <div
      v-if="editJournal"
      class="form-group mt-1 d-flex align-items-center"
      v-bind:class="errors.has('customer') ? 'has-error' : ''"
      style="height: 2.25rem; width:460px"
    >
      <b-input
        style="border: none;"
        list="customers"
        class="w-75"
        placeholder="Select Account Name"
        required
      />
      <datalist id="customers">
        <option v-for="(account, index) in list.accountData" :key="index" :value="account.text" />
      </datalist>
      <p v-if="errors.has('customer') !== null"></p>
       <b-icon icon="x-circle" scale="2" variant="danger" @click="handleClick()" ></b-icon>
    </div>
    <p :title="title" v-else class="w-75" @click="handleClick()">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'name-account',
  data() {
    return {
    editJournal: false,
    list: {
        accountData: []
    },
    model: {
        accountNameSelected: ''
    },
    apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
      },
    };
  },
  props: {
    title: String,
    accountNameSelected: String
  },

  mounted() {
    this.fetchJournalAccount();
  },
  methods: {

    handleClick(){
        this.editJournal = !this.editJournal
    },
    fetchJournalAccount() {
      this.$http.get(this.apiUrl.account + '?journalAccountType=D').then((response) => {
        this.list.accountData = [];
        response?.data?._embedded?.journal_account?.forEach((data) => {
          this.list.accountData.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountName,
          });
        });
      });
    },
  },
};
</script>
